import { PROFICIENCY_LIST_COUNT } from '../../../settings.js'
import connector from '../../connector.js'

/**
 * Get Testable
 * @param {Object} options
 * @param {number} options.id Testable ID
 */
export function get ({ id }) {
  return connector.get(`proficiency/certified-testable/${id}`).json()
}

/**
 * Get Testable list
 * @param {Object} filter Filter options
 * @param {string} filter.search Search term
 * @param {number} filter.offset Offset value
 * @param {number} [filter.limit=100] Number of results
 * @param {import('ky').Options} [options] Request options
 */
export function getList ({ search, offset, limit = PROFICIENCY_LIST_COUNT }, options) {
  const searchParams = { limit, search, offset }
  return connector.get('proficiency/certified-testable', { searchParams, ...options }).json()
}

/**
 * Create new Certified Testable
 * @param {Object} options
 * @param {Object} options.data Testable data
 */
export function create ({ data }) {
  return connector.post('proficiency/certified-testable', data).json()
}

/**
 * Create multiple new Certified Testables (bulk create)
 * @param {Object} options
 * @param {Array} options.data Certified Testable data
 */
export function createBulk ({ data }) {
  return connector.post('proficiency/certified-testable/bulk', data)
}

/**
 * Update existing CertifiedTestable
 * @param {Object} options
 * @param {number} options.id CertifiedTestable ID
 * @param {Object} options.data CertifiedTestable data
 */
export function update ({ id, data }) {
  return connector.patch(`proficiency/certified-testable/${id}`, data).json()
}

/**
 * Remove Testable
 * @param {Object} options
 * @param {number} options.id CertifiedTestable ID
 */
export function remove ({ id }) {
  return connector.delete(`proficiency/certified-testable/${id}`).json()
}

export function preflight (id) {
  return connector.get(`proficiency/certified-testable/${id}/delete-preflight`).json()
}
